import AccountButton from '@Components/AccountButton';
import { Bell } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useUnreadMessages } from '@Hooks/useUnreadMessages';
import { useDocumentTitleBadge } from '@Hooks/useDocumentTitleBadge';

const Topbar = () => {
  const navigate = useNavigate();
  const { data } = useUnreadMessages();
  const total = data?.total ?? 0;

  useDocumentTitleBadge(total);

  return (
    <aside className="flex w-full items-center justify-end gap-4 border-b border-zinc-200 bg-white p-4">
      <div className="py-2 text-center">
        <a
          href="mailto:appsupport@bylandmark.com"
          className="text-sm underline"
        >
          Need Help? Contact Support
        </a>
      </div>
      <button
        type="button"
        onClick={() => navigate('/inbox')}
        className="relative rounded-full p-2 hover:bg-zinc-100"
        aria-label={total > 0 ? `${total} unread messages` : 'Messages'}
      >
        <Bell className="size-5 text-zinc-600" />
        {total > 0 && (
          <span className="absolute -top-0.5 -right-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-semibold text-white">
            {total > 9 ? '9+' : total}
          </span>
        )}
      </button>
      <AccountButton />
    </aside>
  );
};

export default Topbar;
